import { create } from "zustand";

export type SamplingMode = "save" | "order";

export interface SamplingConfirmItem {
  field_id: string;
  field_name: string;
  kind: "points" | "zones";
  count: number; // sample points or zones for this field
}

export interface SamplingConfirmRequest {
  items: SamplingConfirmItem[];
  // the caller's execution for the chosen mode (persist ± order + its own invalidations/navigation). The
  // dialog awaits it and shows a spinner; throwing surfaces an error in the dialog.
  run: (mode: SamplingMode) => Promise<void>;
  // ZONE flows: when present, the dialog offers a third option, "Save & Download" run('save') then
  // this, which downloads the zone file(s) (same smooth/clip/color chain as the map tab's Download
  // Zones).
  download?: () => Promise<void>;
  /*
   *
   * The points ARE what this confirmation is about, so they ride the request rather than being
   * fetched a second time by whoever shows them — two resolutions of one design could disagree, and
   * the user would be looking at points that are not the ones being priced.
   */
  preview?: { field_id: string; fc: GeoJSON.FeatureCollection };
}

interface SamplingConfirmState {
  pending: SamplingConfirmRequest | null;
  /*
   *
   * This suppresses the FRAME, never the REQUEST: closing the animation clears the flag and the
   * root dialog appears, so an order confirmation can never be swallowed by dismissing a
   * decoration.
   */
  hosted: boolean;
  setHosted: (v: boolean) => void;
  request: (r: SamplingConfirmRequest) => void;
  clear: () => void;
}

export const useSamplingConfirm = create<SamplingConfirmState>((set) => ({
  pending: null,
  hosted: false,
  setHosted: (hosted) => set({ hosted }),
  request: (pending) => set({ pending }),
  clear: () => set({ pending: null, hosted: false }),
}));
